import { AllRipplesModal } from "@dashboard/ripples/components/AllRipplesModal";
import { useAllRipplesModalState } from "@dashboard/ripples/state";
import { Box } from "@saleor/macaw-ui-next";
import { type ReactElement, type ReactNode } from "react";

import { DeprecationBanner } from "./DeprecationBanner/DeprecationBanner";
import { Menu } from "./menu";
import { MountingPoint } from "./MountingPoint";
import { UserInfo } from "./user";

interface SidebarContentProps {
  headerAction?: ReactNode;
}

export const SidebarContent = ({ headerAction }: SidebarContentProps): ReactElement => {
  const { isModalOpen, setModalState } = useAllRipplesModalState();

  return (
    <Box
      backgroundColor="default2"
      as="aside"
      height="100%"
      display="grid"
      __gridTemplateRows="auto 1fr auto"
    >
      <Box>
        <MountingPoint action={headerAction} />
        <DeprecationBanner />
      </Box>
      <Menu />
      <UserInfo />
      <AllRipplesModal
        open={isModalOpen}
        onChange={open => {
          setModalState(open);
        }}
      />
    </Box>
  );
};
